import { financeAPI } from "../../axios";

export const actions = {
  /** Subsidiary Ledgers */
  createSubsidiaryLedger(context, { data, campusId }) {
    return financeAPI.post(`SubsidiaryLedger/Create/${campusId}`, data);
  },
  getSubsidiaryLedgersByCampus(context, campusId) {
    return financeAPI.get(`SubsidiaryLedger/Campus/${campusId}`);
  },
  getSingleSubsidiaryLedger(context, id) {
    return financeAPI.get(`SubsidiaryLedger/${id}`);
  },
  removeSubsidiaryLedger(context, subsidiaryLedgerId) {
    return financeAPI.delete(`SubsidiaryLedger/Remove/${subsidiaryLedgerId}`);
  },
  updateSubsidiaryLedger(context, { subsidiaryLedgerId, data }) {
    return financeAPI.put(`SubsidiaryLedger/Update/${subsidiaryLedgerId}`, data);
  },
  getSubsidiaryLedgerByDvNumber(context, dvNumber) {
    return financeAPI.get(`SubsidiaryLedger/DvNumber/${dvNumber}`);
  },
  getSingleSubsidiaryLedgerById(context, id) {
    return financeAPI.get(`SubsidiaryLedgerItem/${id}`);
  },
  getSubsidiaryLedgerItemsBySubsidiaryLedger(context, subsidiaryLedgerId) {
    return financeAPI.get(`SubsidiaryLedgerItem/SubsidiaryLedger/${subsidiaryLedgerId}`);
  },
  createSubsidiaryLedgerItem(context, data) {
    return financeAPI.post(`SubsidiaryLedgerItem/Create`, data);
  },
  updateSubsidiaryLedgerItem(context, { id, data }) {
    return financeAPI.put(`SubsidiaryLedgerItem/Update/${id}`, data);
  },
  removeSubsidiaryLedgerItem(context, id) {
    return financeAPI.delete(`SubsidiaryLedgerItem/Remove/${id}`);
  },
  getSubsidiaryLedgerByJevEntry(id, jevEntryId){
    return financeAPI.get(`SubsidiaryLedgerItem/JevEntry/${jevEntryId}`)
  }
};
